export enum DoubleEntryType {
    None = 0,
    Debit = 1,
    Credit = 2,
    Plus = 3,
    Minus = 4,
    No = 5,
}